import type { AmbassadorBootstrap } from '@wix/ambassador-bootstrap-plugin';
import type { IHttpClient } from '@wix/http-client';
import type { QueryClient } from '@tanstack/react-query';
import { MarketSectionsService } from '../market-sections';
import { BundleAppsService } from '../bundle-apps';
import type { ErrorHandlerPublicAPI } from '@wix/error-handler';

export class AppBenefitsService {
  private readonly marketSectionsService: MarketSectionsService;
  private readonly bundleAppsService: BundleAppsService;

  constructor(
    rpcClient?: AmbassadorBootstrap,
    httpClient?: IHttpClient,
    queryClient?: QueryClient,
    errorHandler?: ErrorHandlerPublicAPI,
  ) {
    this.marketSectionsService = new MarketSectionsService(
      rpcClient,
      httpClient,
      queryClient,
      errorHandler,
    );
    this.bundleAppsService = new BundleAppsService(
      rpcClient,
      httpClient,
      queryClient,
      errorHandler,
    );
  }

  public async get(): Promise<{ appId: string }[]> {
    const [realBenefits, bundleAppsBenefits] = await Promise.all([
      this.marketSectionsService.getAppBenefitsSections(),
      this.bundleAppsService.get(),
    ]);
    const benefitsAppIds = Array.from(
      new Set([
        ...realBenefits.map((benefit) => benefit.appId),
        ...bundleAppsBenefits.map((benefit) => benefit.appId),
      ]),
    );

    return benefitsAppIds.map((appId) => ({ appId }));
  }
}
